import { FC, useCallback } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Typography,
  Box,
  Container,
  IconButton,
} from '@material-ui/core';
import './index.scss'
import { Row } from 'components/Row';
import CloseIconModal from 'assets/icons/CloseIconModal';
import { useDispatch } from 'react-redux';
import { closeModal } from 'store/modules/ModalActions';

interface LayoutModalProps {
  title: string;
  content: string | React.ReactNode;
  confirmCallback: () => void;
  cancelCallback: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmThemeButton?: string;
  cancelThemeButton?: string;
  modalKey: string;
}

const LayoutModal: FC<LayoutModalProps> = ({
  modalKey,
  title,
  content,
  confirmCallback,
  cancelCallback,
  confirmLabel,
  cancelLabel,
  confirmThemeButton,
  cancelThemeButton,
}) => {
  const dispatch = useDispatch();

  const toClose = useCallback(() => {
    dispatch(closeModal(modalKey));
  }, [dispatch, modalKey]);

  const toCancel = useCallback(() => {
    if (typeof cancelCallback === 'function') {
      cancelCallback();
    }
    toClose();
  }, [cancelCallback, toClose]);

  return (
    <Dialog
      className='LayoutModal'
      open={true}
      onClose={toCancel}
      closeAfterTransition
      disableEscapeKeyDown
      fullScreen
    >
      <Box>
        <DialogTitle className='LayoutModal_dialogTitle'>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography className='LayoutModal_titleText'>
              {title}
            </Typography>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                toCancel();
              }}
              size="small"
            >
              <CloseIconModal style={{ width: 'auto', height: '22px' }} />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent>
          {content}
        </DialogContent>

        <Container className='LayoutModal_dialogActions'>
          <Row className='LayoutModal_row'>
            <Box
              className='LayoutModal_box-buttons'
              onClick={(e) => e.stopPropagation()}
            >
              <Button
                className={`LayoutModal_action-button ${cancelThemeButton || ''}`}
                variant='contained'
                onClick={(e) => {
                  e.stopPropagation();
                  cancelCallback?.();
                  dispatch(closeModal(modalKey));
                }}
              >
                {cancelLabel || 'Cancelar'}
              </Button>

              <Button
                className={`LayoutModal_action-button ${confirmThemeButton || ''}`}
                variant='contained'
                onClick={(e) => {
                  e.stopPropagation();
                  confirmCallback?.();
                  dispatch(closeModal(modalKey));
                }}
              >
                {confirmLabel || 'Confirmar'}
              </Button>
            </Box>
          </Row>
        </Container>
      </Box>
    </Dialog>
  );
};

export default LayoutModal;